import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { scroller } from 'react-scroll'
import MasterData from '../../data/MasterData'
import StationItem from './TrainPositionStationItem'
import TokyuStationItem from './TrainPositionTokyuStationItem'
import TokyuParallelStationItem from './TrainPositionTokyuParallelStationItem'
import BlankRow from './TrainPositionBlankRow'
import { showAlert } from '../../utils/Alert'
import { FormattedMessage } from 'react-intl'

const TrainPositionList = (props) => {
  const { trains, lineName, themeName, openTrainSelectModal, appVersion } = props
  const intl = useIntl()
  const navigate = useNavigate()

  useEffect(() => {
    window.locateStation = (lat, lng) => {
      const nearestStation = getNearestStation(lat, lng)
      if (!nearestStation) {
        showAlert(intl.formatMessage({ id: 'App.TrainPositions.dialog.outsideArea' }))
        return
      }
      if (MasterData.isOnIzuminoLine(nearestStation.id)) {
        navigate(`/lines/izumino/trains`)
      } else if (MasterData.isOnMainLine(nearestStation.id)) {
        navigate(`/lines/main/trains`)
      }
      scrollToStation(nearestStation.id)
    }
  }, [])

  const getNearestStation = (lat, lng) => {
    const allStations = MasterData.stations()

    const nearestStationWithSqDist = allStations.reduce((nearest, station) => {
      const sqDist = abstractDistance(station.lat, station.lng, lat, lng)
      return sqDist < nearest.sqDist ? {station, sqDist} : nearest
    }, {station: null, sqDist: Infinity})

    return Math.sqrt(nearestStationWithSqDist.sqDist) <= 0.3 ? nearestStationWithSqDist.station : null
  }

  const abstractDistance = (lat1, lng1, lat2, lng2) => {
    return ( ((lat1 - lat2) / 0.0111)**2 + ((lng1 - lng2) / 0.0091)**2 )
  }

  const scrollToStation = (stationId) => {
    scroller.scrollTo(`station${stationId}`)
  }

  const stations = () => {
    const lineId = MasterData.lineIdByLineName(lineName)
    return MasterData.allStationsOnTabId(lineId)
  }

  return (
    <ul className="d-TrainPosition-station">
      {lineName === 'izumino' ? <BlankRow key='blank' themeName={themeName} /> : null}

      {stations().map((station, i) => {
        if (Array.isArray(station)) {
          return (
            <div key={`stations${i}-${station[0].id}_${station[1].id}`} className={`d-TrainPosition-stationItemContainer`}>
              <TokyuStationItem
                key={`station${i}-0-${station[0].id}`}
                lineName={lineName}
                trains={trains}
                station={station[0]}
                themeName={themeName}
                openTrainSelectModal={openTrainSelectModal}
              />
              <TokyuStationItem
                key={`station${i}-1-${station[1].id}`}
                lineName={lineName}
                trains={trains}
                station={station[1]}
                themeName={themeName}
                openTrainSelectModal={openTrainSelectModal}
              />
            </div>
          )
        } else if (lineName === 'izumino' && station.id === 10) { // いずみ野線上部
          return null
        } else if (station.id === 63) { // 元住吉
          return (
            <TokyuParallelStationItem
              key={`station${i}-${station.id}`}
              lineName={lineName}
              trains={trains}
              station={station}
              themeName={themeName}
              openTrainSelectModal={openTrainSelectModal}
            />
          )
        } else {
          return (
            <StationItem
              key={`station${i}-${station.id}`}
              lineName={lineName}
              trains={trains}
              station={station}
              themeName={themeName}
              appVersion={appVersion}
            />
          )
        }
      })}
    </ul>
  )
}

TrainPositionList.propTypes = {
  trains: PropTypes.array.isRequired,
  lineName: PropTypes.string.isRequired,
  themeName: PropTypes.string.isRequired,
  openTrainSelectModal: PropTypes.func.isRequired,
  appVersion: PropTypes.string,
}

export default TrainPositionList
